{
  "title": "Partners",
  "subtitle": "Resellers who sell OnBrand Mail to their own customers.",
  "addPartner": "Add a partner",
  "loadError": "Could not load partners",
  "emptyTitle": "No partners yet",
  "emptyDescription": "A partner sells to their own customers and keeps a margin. Add one, then attribute their customers to them from each tenant.",
  "colPartner": "Partner",
  "colMargin": "Margin",
  "colCustomers": "Customers",
  "colStatus": "Status",
  "colPayouts": "Payouts",
  "colCustomer": "Customer",
  "colPaid": "Paid",
  "colRate": "Rate",
  "colEarned": "Earned",
  "statusPending": "Pending",
  "statusActive": "Active",
  "statusSuspended": "Suspended",
  "payoutsNotOnboarded": "Not onboarded",
  "payoutsOnboarding": "Onboarding",
  "payoutsReady": "Ready",
  "payoutsRestricted": "Restricted",
  "payoutsBadge": "Payouts: {{status}}",
  "marginBadge": "{{margin}} margin",
  "commissionOwed": "Owed",
  "commissionPaid": "Paid",
  "commissionReversed": "Reversed",
  "commissionHeld": "Held",
  "updateError": "Could not update that partner.",
  "stripeOnboardingError": "Could not email the Stripe invite.",
  "partnerVerb": "{{name}} {{verb}}.",
  "partnerAdded": "{{name}} added.",
  "partnerAddedInvited": "{{name}} added and invited to set up Stripe payouts.",
  "partnerAddedNoEmail": "{{name}} added — invite email could not be sent. Open the partner and use Resend invite.",
  "verbReactivated": "reactivated",
  "verbSuspended": "suspended",
  "activate": "Activate",
  "reactivate": "Reactivate",
  "suspend": "Suspend",
  "emailStripeInvite": "Email Stripe invite",
  "resendStripeInvite": "Resend Stripe invite",
  "stripeInviteSent": "Stripe setup invite sent to {{email}}.",
  "stripeInviteCopy": "Could not email {{email}}. Invite link copied to the clipboard.",
  "stripeAlreadyOnboarded": "This partner has already finished Stripe payouts setup.",
  "startStripeOnboarding": "Email Stripe invite",
  "newOnboardingLink": "Resend Stripe invite",
  "marginPercent": "Margin (%)",
  "billingEmail": "Billing email",
  "billingEmailDescription": "Where invoices, commission statements, and the Stripe payouts invite go.",
  "billingEmailPlaceholder": "accounts@northern-it.example",
  "commissions": "Commission",
  "noCommissions": "Nothing earned yet. Commission is recorded when a referred customer pays an invoice, not when one is raised.",
  "createTitle": "Add a partner",
  "createIntro": "A partner sells to their own customers and keeps a margin on the list price. Attribute their customers to them from each tenant afterwards.",
  "createError": "Could not add that partner",
  "createErrorShort": "Could not add that partner.",
  "partnerFallback": "Partner",
  "nameLabel": "Name",
  "namePlaceholder": "Northern IT",
  "slugLabel": "Slug",
  "slugDescription": "Appears in portal routes and log lines. Lower case, digits and hyphens.",
  "slugPlaceholder": "northern-it",
  "marginLabel": "Margin",
  "marginDescription": "Share of the list price this partner keeps.",
  "stripePayouts": "Stripe payouts",
  "stripeActive": "Stripe will accept transfers to this partner. Commission is sent hourly.",
  "stripeNeedsInfo": "Stripe still wants information before it will pay this partner. Commission keeps accruing meanwhile and is sent as soon as it can be.",
  "stripeNeedsOnboarding": "This partner cannot be paid commission until they complete Stripe onboarding. Only needed for referred customers — wholesale partners are invoiced instead.",
  "customersAttributed": "{{count}} customer attributed. Wholesale customers are invoiced to this partner at {{wholesale}} of list; referred customers pay us directly and the margin is transferred once we are paid.",
  "customersAttributed_other": "{{count}} customers attributed. Wholesale customers are invoiced to this partner at {{wholesale}} of list; referred customers pay us directly and the margin is transferred once we are paid.",
  "suspendedAlert": "Suspended: no new customer can be attributed and no new subscription billed to them. Subscriptions already running are untouched.",
  "statementError": "Could not load the statement",
  "multiCurrencyNote": "These entries span more than one currency, so the totals above are counts of minor units rather than an amount. Read the lines instead.",
  "offboardedCustomer": "Offboarded customer",
  "noAccessTitle": "No access to partners",
  "noAccessBody": "Reseller arrangements are managed by OnBrand Mail staff.",
  "viewAs": "View as partner",
  "viewAsStarted": "Viewing the portal as {{name}}.",
  "viewAsError": "Could not start viewing as that partner.",
  "viewAsBannerTitle": "Viewing as {{name}}",
  "viewAsBannerBody": "You see only this partner's customers and what their administrators can reach. Platform admin tools are hidden until you exit.",
  "exitViewAs": "Exit partner view",
  "viewAsExitError": "Could not exit partner view.",
  "resendPortalInvite": "Resend portal invite",
  "portalAccess": "Portal access",
  "portalAccessHint": "Lets somebody sign in and administer this partner's customers. Separate from Stripe payouts setup.",
  "portalInviteTitle": "Invite to the portal",
  "portalInviteHint": "Send {{name}} an email so they can sign in and set up their partner account. Sign-in is all it takes — no password to create.",
  "portalInviteEmail": "Work email",
  "portalInviteEmailDesc": "The address they will sign in with. Defaults to the billing contact.",
  "portalInviteDifferentOrgDesc": "Partners almost always sign in from their own directory. Untick only if they share yours.",
  "portalInviteSent": "Portal invite sent to {{email}}.",
  "portalInviteResent": "Portal invite resent to {{email}}.",
  "portalInviteNoEmailTitle": "{{email}} invited — email could not be sent",
  "portalInviteNoEmailBody": "The invitation is waiting. Tell them to sign in with that address; the role applies itself when they arrive.",
  "portalInviteErrorTitle": "Not invited",
  "portalInviteError": "Could not send that portal invite."
}
